import React from 'react';

interface ChemicalFormulaProps {
  formula: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Component that renders chemical formulas with proper subscript formatting
 * Converts numbers to subscript tags for proper chemical notation
 * BUT NOT coefficients (numbers at the start of molecules)
 * 
 * Examples:
 * - "H2O" → "H₂O" (with subscripts)
 * - "2H2O" → "2H₂O" (coefficient stays normal, element count becomes subscript)
 * - "H2SO4" → "H₂SO₄"
 */
export const ChemicalFormula: React.FC<ChemicalFormulaProps> = ({ 
  formula, 
  className, 
  style 
}) => {
  // Convert numbers to subscript HTML, but NOT coefficients at the start
  const formatFormula = (text: string): string => {
    // Split by spaces to handle multiple molecules
    return text.split(' ').map(molecule => {
      // For each molecule, only subscript numbers that come after letters
      return molecule.replace(/([A-Za-z])(\d+)/g, '$1<sub>$2</sub>');
    }).join(' ');
  };

  return (
    <span 
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: formatFormula(formula) }}
    />
  );
};

export default ChemicalFormula;
